import { CSSProperties } from 'react';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { useUserRouteMapperHook } from '@vivli/features/portal/infrastructure/hook';
import { IPageLink } from '@vivli/shared/infrastructure/interface';
import { HorizontalNavContainerComponent } from '@vivli/shared/components';
import { useUserRoles } from '../hooks/use-user-roles.hook';
import { ActiveUserMenuView } from '@vivli/shared/views';
import { useNavigate } from 'react-router';

export const TopLinksMenuComponent = () => {
    const activeLink: IPageLink = null;
    const containerStyle: CSSProperties = {
        height: '100%',
        minWidth: '1000px',
        display: 'grid',
        paddingRight: '10px'
    };

    //
    const { user } = useActiveUserContext();
    const navigate = useNavigate();

    const { getUserRoutes } = useUserRouteMapperHook();
    const { getUserRoleName, getCommands } = useUserRoles();
    const userName = getUserRoleName();

    const allPanelItems = getUserRoutes(user);
    //items to be used in the top tabs EXCEPT for the rightmost tab, which is for
    //management links.
    const topTabItems = allPanelItems?.filter((panelItem) => !panelItem.managementTab);
    const mgmtDropDownItems = allPanelItems?.filter((panelItem) => panelItem.managementTab);

    //commands to be used in the management dropdown, which are not route links
    //but instead execute functions (update profile, change password, logout)
    const commandLinks = getCommands();

    const baseUserLinks: IPageLink[] =
        topTabItems?.map((panelItem) => ({
            title: panelItem.title,
            url: panelItem.url,
            component: null,
            defaultTab: panelItem.defaultTab,
            subLinks: panelItem.subLinks,
            className: panelItem.title + '_class_name'
        })) || [];

    const mgmtLinks: IPageLink[] =
        mgmtDropDownItems?.map((panelItem) => ({
            title: panelItem.title,
            url: `admin/${panelItem.url}`,
            component: null,
            defaultTab: panelItem.defaultTab,
            subLinks: panelItem.subLinks,
            className: panelItem.title + '_class_name'
        })) || [];

    //it happens that all the command links (update profile, change password, logout)
    // are positioned at the bottom, so just concatenate them to the end of the management links
    const allDropdownLinks = [...mgmtLinks, ...commandLinks];

    const handleRequestedAction = (urlTarget?: string, commandTarget?: Function) => {
        if (urlTarget) {
            navigate(urlTarget);
        } else if (commandTarget) {
            commandTarget();
        }
    };

    if (allDropdownLinks && allDropdownLinks.length > 0) {
        baseUserLinks.push({
            title: userName,
            url: null,
            component: null,
            containedComponent: (
                <ActiveUserMenuView
                    userRoleName={userName}
                    actionRequested={(url: string, command: Function) => handleRequestedAction(url, command)}
                    links={allDropdownLinks}
                    isPartner={false}
                />
            )
        });
    }

    return (
        <div style={containerStyle}>
            <HorizontalNavContainerComponent topTabSet={true} links={baseUserLinks} activeLink={activeLink} />
        </div>
    );
};
